import ProgressBar from 'react-bootstrap/ProgressBar';

import logo_tf from '../../assets/images/logo_blue.svg'

export default function Header(props) {


    return(
        <header>
            <div>
                <img src={logo_tf} alt='' />
            </div>
            <ProgressBar now={props?.progress || 0} />
        </header>
    )
}